import { render, staticRenderFns } from "./TypeForm.vue?vue&type=template&id=698ef4bb&"
import script from "./TypeForm.vue?vue&type=script&lang=js&"
export * from "./TypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports